// extracted by mini-css-extract-plugin
export default {"reset_password":"reset-pwd_reset_password__cb5Sf","title":"reset-pwd_title__miC8M","primary_btn":"reset-pwd_primary_btn__i2QPT"};